import { Tabs } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const { TabPane } = Tabs;

interface Tab {
    id: number;
    icon: string;
    name: string;
    component: any;
}

interface Props {
    tabs: Tab[];
    onTabSelected?: any;
    defaultActiveKey?: string;
    tabPosition?: any;
    className?: string;
    activeKey?: string;
}

const Tbs: FunctionComponent<Props> = (props) => {
    const { t } = useTranslation(['f', 'b']);
    return (
        <Tabs
            activeKey={props.activeKey}
            className={props.className}
            tabPosition={props.tabPosition}
            onChange={props.onTabSelected}
            defaultActiveKey={props.defaultActiveKey ? props.defaultActiveKey : '1'}
        >
            {props.tabs.map((tab) => (
                <TabPane
                    tab={
                        <div>
                            {tab.icon && <img src={tab.icon} alt="Tab" />}
                            <p>{t(`f:property.${tab.name}`)}</p>
                        </div>
                    }
                    key={tab.id}
                >
                    {tab.component}
                </TabPane>
            ))}
        </Tabs>
    );
};

export default Tbs;
